export const integrations = {
  seo: {
    title: 'Intégrations – connectez vos applications préférées | Bistroo',
    description: "Connectez Lightspeed, Mollie, Exact et bien plus en un clic avec Bistroo. Découvrez toutes les intégrations disponibles pour votre restaurant.",
  },
  hero: {
    heading: {
      1: 'Vos',
      2: 'applications préférées',
      3: 'intégrées en un seul clic',
    },
    description: {
      1: 'Nous proposons un large éventail d\'intégrations afin que vous puissiez vous concentrer sur ce que vous faites de mieux, sans tracas.',
      2: 'Nos intégrations font en sorte que tout fonctionne sans effort, afin que vous puissiez vous consacrer à la croissance de votre entreprise — et non à la gestion de la technologie. Installation rapide, expérience fluide et sans tracas.',
    },
  },
  cards: {
    card_1: {
      title: 'Choisissez votre intégration',
      text: 'Sélectionnez votre intégration dans notre marketplace d\'applications dans le Bistroo Manager.',
      button: 'Voir le marketplace d\'applications',
      img_alt: '',
    },
    card_2: {
      title: 'Suivez le guide',
      text: 'Nous vous donnons les étapes à suivre pour un processus d\'intégration fluide.',
      button: '',
      img_alt: '',
    },
    card_3: {
      title: 'Activez l\'intégration',
      text: 'Activez l\'intégration dans l\'application de gestion Bistroo et commencez à échanger des données.',
      button: '',
      img_alt: '',
    },
    card_4: {
      title: 'Des questions ?',
      text: 'Avez-vous des questions ou souhaitez-vous que quelqu\'un jette un œil à votre intégration ? N\'hésitez pas à nous contacter.',
      button: '',
      img_alt: '',
    },
    card_5: {
      title: 'Vous êtes prêt à démarrer !',
      text: 'Après avoir terminé ces étapes, votre logiciel est entièrement intégré.',
      button: '',
      img_alt: '',
    },
  },
  partner: {
    title: 'Vous souhaitez aussi devenir partenaire ?',
    text: {
      1: 'Inscrivez-vous bientôt via notre portail partenaire. En attendant, prenez',
      2: 'contact avec nous',
      3: '.',
    },
  },
}
